const factory = function factory({ window, thn }) {
    const isBookingConfirmPage = () => thn.dataLayerHelper.get('page_info.page_type') === 'bookingpage' || !!window.location.pathname.match(/booking/);
    const refreshSite = thn.debounce(() => {
        // When you pay for the reservation it offers you the addons and we don't want to refresh the site in that case
        if (isBookingConfirmPage()) {
            return;
        }
        thn.siteCheck().catch(() => { });
    }, 400);
    const updateSiteOnDataLayerEvents = (data) => {
        const message = data.message;
        if (message?.event === 'purchase' || message?.event === 'pageview') {
            refreshSite();
        }
    };
    return {
        getId() {
            return '442';
        },
        check() {
            return window.location.hostname.includes('bestwestern');
        },
        boot() {
            thn.bus.on('dataLayer:push', updateSiteOnDataLayerEvents, true);
            thn.bus.on('thn:on-state-change', refreshSite);
        },
        shutdown() {
            thn.bus.detach('dataLayer:push', updateSiteOnDataLayerEvents);
            thn.bus.detach('thn:on-state-change', refreshSite);
        },
        getSiteId() {
            const hotelIdDom = document.querySelector('div[data-hotel-code]')?.getAttribute('data-hotel-code');
            const hotelIdPath = !isBookingConfirmPage() && window.location.pathname.match(/\d+/)?.[0];
            const hotelId = hotelIdDom || hotelIdPath;
            if (hotelId) {
                return { externalId: hotelId };
            }
            if (!isBookingConfirmPage()) {
                return { accountKey: '33E5F1A10DFAB8F76C1EC273D9B0B99F' };
            }
            return null;
        },
    };
};

export { factory };
